/* unplugin-vue-components disabled */import { render } from "./TableForm.vue?vue&type=template&id=510f9f6f&scoped=true&ts=true"
import script from "./TableForm.vue?vue&type=script&lang=ts"
export * from "./TableForm.vue?vue&type=script&lang=ts"

import "./TableForm.vue?vue&type=style&index=0&id=510f9f6f&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510f9f6f"]])

export default __exports__